// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* iOS safe-area insets.
   The viewport meta sets viewport-fit=cover so the page lays out over the whole
   screen. Without it Safari insets the page inside the safe area and fills the gap
   with the page background: in landscape on a notched iPhone that is ~62 CSS px on
   EACH side (measured on a 16 Pro Max: 13% of the width) showing as black bars.
   Having taken the full screen we now owe it to keep our own UI clear of the
   Dynamic Island and the home indicator, which is what these are for.
   They are 0 on every device without insets, so nothing else changes. */
:root {
  --safe-top: env(safe-area-inset-top, 0px);
  --safe-right: env(safe-area-inset-right, 0px);
  --safe-bottom: env(safe-area-inset-bottom, 0px);
  --safe-left: env(safe-area-inset-left, 0px);
}

html,
body,
#cesiumContainer {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#igcFileDisplay {
  width: 100%;
  height: 100%;
}

#mapWrapper {
  width: 100%;
  height: 100%;
}

.logo-container {
  width: 150px;
  height: 62px;
  position: absolute;
  z-index: 1;
  background-size: cover;
  /* No --safe-bottom here: moveLogo() in LineChart.js overwrites \`bottom\` inline,
     measuring from the chart's live top edge, so it already follows the inset chart.
     Adding the inset here would be dead code, and adding it there would double it. */
  bottom: 5%;
  left: calc(1% + var(--safe-left));
  opacity: 0.8;
}

@media (max-width: 767px) {
  /* or any other breakpoint for mobile */
  .logo-container {
    width: 112.5px;
    height: 46.5px;
  }
}
.distance-legend {
  /* Vertical position is owned by moveLogo() too — see .logo-container above. */
  bottom: 60px !important;
  right: calc(50% - 65px);
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}

.cesium-credit-logoContainer:hover {
  cursor: pointer;
}

.cesium-credit-logoContainer div a {
  display: none;
}

.cesium-credit-textContainer div a {
  display: none;
}

.cesium-credit-textContainer a,
.cesium-credit-expand-link {
  display: none !important;
}

.cesium-viewer-fullscreenContainer {
  display: none !important;
}

.cesium-infoBox {
  max-width: 600px;
}

.cesium-infoBox-camera {
  display: none !important;
}

#upload {
  display: none;
}

/* Hide Base Layer Picker */
.cesium-viewer-toolbar > button {
  display: none !important;
}

.disabled {
  pointer-events: none;
  /* Disable all mouse events */
  opacity: 0.5;
  /* Make it look visually disabled */
  color: #e0e0e0;
}

/* cesium-navigation-es6 pins these to right: 0 / right: 30px. */
.compass {
  top: calc(20px + var(--safe-top)) !important;
  right: var(--safe-right) !important;
}

.navigation-controls {
  top: calc(125px + var(--safe-top)) !important;
  right: calc(30px + var(--safe-right)) !important;
}

/* Cesium's credit line sits at bottom: 0; left: 0. */
.cesium-viewer-bottom {
  bottom: var(--safe-bottom) !important;
  left: var(--safe-left) !important;
}

.no-select-item {
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}`, "",{"version":3,"sources":["webpack://./src/burnair/modules/3dViewer/3dMain.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;wEAAA;AAQA;EACE,yCAAA;EACA,6CAAA;EACA,+CAAA;EACA,2CAAA;AAEF;;AACA;;;EAGE,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;AAEF;;AACA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EAEA,UAAA;EACA,sBAAA;EACA;;qFAAA;EAGA,UAAA;EACA,iCAAA;EACA,YAAA;AACF;;AAEA;EACE,uCAAA;EACA;IACE,cAAA;IACA,cAAA;EACF;AACF;AAEA;EACE,8EAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;;EAEE,wBAAA;AAAF;;AAGA;EACE,wBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,wBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA,2BAAA;AACA;EACE,wBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,6BAAA;EACA,YAAA;EACA,mCAAA;EACA,cAAA;AAAF;;AAGA,gEAAA;AACA;EACE,4CAAA;EACA,mCAAA;AAAF;;AAGA;EACE,6CAAA;EACA,gDAAA;AAAF;;AAGA,qDAAA;AACA;EACE,qCAAA;EACA,iCAAA;AAAF;;AAGA;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;AAAF","sourcesContent":["/* iOS safe-area insets.\n   The viewport meta sets viewport-fit=cover so the page lays out over the whole\n   screen. Without it Safari insets the page inside the safe area and fills the gap\n   with the page background: in landscape on a notched iPhone that is ~62 CSS px on\n   EACH side (measured on a 16 Pro Max: 13% of the width) showing as black bars.\n   Having taken the full screen we now owe it to keep our own UI clear of the\n   Dynamic Island and the home indicator, which is what these are for.\n   They are 0 on every device without insets, so nothing else changes. */\n:root {\n  --safe-top: env(safe-area-inset-top, 0px);\n  --safe-right: env(safe-area-inset-right, 0px);\n  --safe-bottom: env(safe-area-inset-bottom, 0px);\n  --safe-left: env(safe-area-inset-left, 0px);\n}\n\nhtml,\nbody,\n#cesiumContainer {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n#igcFileDisplay {\n  width: 100%;\n  height: 100%;\n}\n\n#mapWrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.logo-container {\n  width: 150px;\n  height: 62px;\n  position: absolute;\n  // left: 20px;\n  z-index: 1;\n  background-size: cover;\n  /* No --safe-bottom here: moveLogo() in LineChart.js overwrites `bottom` inline,\n     measuring from the chart's live top edge, so it already follows the inset chart.\n     Adding the inset here would be dead code, and adding it there would double it. */\n  bottom: 5%;\n  left: calc(1% + var(--safe-left));\n  opacity: 0.8;\n}\n\n@media (max-width: 767px) {\n  /* or any other breakpoint for mobile */\n  .logo-container {\n    width: 112.5px;\n    height: 46.5px;\n  }\n}\n\n.distance-legend {\n  /* Vertical position is owned by moveLogo() too — see .logo-container above. */\n  bottom: 60px !important;\n  right: calc(50% - 65px);\n  -webkit-user-select: none;\n  /* Safari */\n  -ms-user-select: none;\n  /* IE 10 and IE 11 */\n  user-select: none;\n  /* Standard syntax */\n}\n\n.cesium-credit-logoContainer:hover {\n  cursor: pointer;\n}\n\n.cesium-credit-logoContainer div a {\n  display: none;\n}\n\n.cesium-credit-textContainer div a {\n  display: none;\n}\n\n.cesium-credit-textContainer a,\n.cesium-credit-expand-link {\n  display: none !important;\n}\n\n.cesium-viewer-fullscreenContainer {\n  display: none !important;\n}\n\n.cesium-infoBox {\n  max-width: 600px;\n}\n\n.cesium-infoBox-camera {\n  display: none !important;\n}\n\n#upload {\n  display: none;\n}\n\n/* Hide Base Layer Picker */\n.cesium-viewer-toolbar > button {\n  display: none !important;\n}\n\n.disabled {\n  pointer-events: none;\n  /* Disable all mouse events */\n  opacity: 0.5;\n  /* Make it look visually disabled */\n  color: #e0e0e0;\n}\n\n/* cesium-navigation-es6 pins these to right: 0 / right: 30px. */\n.compass {\n  top: calc(20px + var(--safe-top)) !important;\n  right: var(--safe-right) !important;\n}\n\n.navigation-controls {\n  top: calc(125px + var(--safe-top)) !important;\n  right: calc(30px + var(--safe-right)) !important;\n}\n\n/* Cesium's credit line sits at bottom: 0; left: 0. */\n.cesium-viewer-bottom {\n  bottom: var(--safe-bottom) !important;\n  left: var(--safe-left) !important;\n}\n\n.no-select-item {\n  -webkit-user-select: none;\n  /* Safari */\n  -ms-user-select: none;\n  /* IE 10 and IE 11 */\n  user-select: none;\n  /* Standard syntax */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
